import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams } from "react-router-dom";

import SignUpImg from "../../assets/authPages/signUpRightImg.png";

import OgImage from "../../assets/landingPages/homePage/Hero.png";
import { ReactComponent as GlobeIcon } from "../../assets/landingPages/header/globe.svg";
import { ReactComponent as GlobeIconDark } from "../../assets/landingPages/header/globeDark.svg";
import { ReactComponent as BilBioLogo } from "../../assets/NewLogo.svg";
import { ReactComponent as BilBioLogoDark } from "../../assets/NewLogoDark.svg";

import GrrenFillCheck from "../../assets/tick-circle.png";

import { useDispatch, useSelector } from "react-redux";
import { registerUser, resetUser } from "../../redux/slices/auth/authSlice";
import { creatingBioLink } from "../../redux/slices/bioLink/bioLinkSlice";
import { toast } from "react-hot-toast";

import { useNavigate } from "react-router-dom";

import * as yup from "yup";

import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import useLocales from "../../hooks/useLocales";
import useSettings from "../../hooks/useSettings";
import { Helmet } from "react-helmet";
import ReCAPTCHA from "react-google-recaptcha";
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha,
} from "react-google-recaptcha-v3";

const baseUrl = process.env.REACT_APP_API_URL;

const SignUp = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate, onChangeLang, allLangs } = useLocales();
  // const { pageNameParam } = useParams();
  const { email, code } = useParams(); // Access route parameters

  const { themeDirection } = useSettings();
  const [nameAvailable, setNameAvailable] = useState(null);
  const [nameLoading, setNameLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isOpenLangModal, setIsOpenLangModal] = useState(false); // Variable to manage the language modal open/close state
  const [isOpenLangMModal, setIsOpenLangMModal] = useState(false); // Variable to manage the mobile language modal open/close state
  const iconRef = useRef(); // Reference for icon element
  const modalRef = useRef(); // Reference for modal element
  const schema = yup.object().shape({
    email: yup
      .string()
      .email("Please enter a valid E-mail")
      .required("E-mail is required"),
    pageName: yup
      .string()
      .max(40)
      .test(
        "no-symbols",
        translate("auth.page_name_cannot_contain_symbols"),
        (value) => /^[a-zA-Z0-9\s]+$/.test(value)
      )
      .required(translate("auth.page_name_required")),
  });

  const {
    register,
    handleSubmit,
    setError,
    reset,
    setValue,
    clearErrors,
    formState: { errors, isValid },
  } = useForm({
    resolver: yupResolver(schema),
  });
  function onChange(value) {
    console.log("Captcha value:", value);
  }
  // Adding an event listener to handle clicks outside the language modal (for desktop)
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        isOpenLangModal &&
        modalRef.current &&
        !modalRef.current.contains(e.target) &&
        !iconRef.current.contains(e.target)
      ) {
        setIsOpenLangModal(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpenLangModal]);
  
  useEffect(() => {
    if (email) {
      setValue("email", email);
      // const formData = {
      //   email: email,
      // };
      // setNameLoading(true);
      // setSearch(formData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  // useEffect(() => {
  //   if (pageNameParam) {
  //     setValue("pageName", pageNameParam);
  //     const formData = {
  //       pageName: pageNameParam,
  //     };
  //     setNameLoading(true);
  //     setSearch(formData);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pageNameParam]);

  const {
    regUserState,
    regError,
    regSuccess,
    regLoading,
    // nameLoading,
    // nameSuccess,
    regErrMsg,
  } = useSelector((state) => state.user);

  // register User status
  console.log(regUserState, "regUserState");

  useEffect(() => {
    let toastId;

    if (regLoading) {
      toastId = toast.loading("Loading...");
    }
    if (regError) {
      toast?.dismiss(toastId);
      toast.error(regUserState?.message);
    }
    if (regSuccess && regUserState?.status === "success" && regUserState.data) {
      toast.dismiss(toastId);
      toast.success(regUserState?.message);
      localStorage.setItem("registerData", JSON.stringify(regUserState.data));
      const CreatedBioLinkData = {
        tag: "main",
        registeredUserID: regUserState?.data?.user_id,
      };
      dispatch(creatingBioLink(CreatedBioLinkData));
      navigate("/auth/passwordPage");
    }
    if (regSuccess && regUserState?.status === "failed") {
      toast.dismiss(toastId);
      toast.error(regUserState?.message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regLoading, regErrMsg]);

  const pageNameInputChangeHandler = async (e) => {
    if (e.target.value !== "") {
      if (!/^[a-zA-Z0-9\s]+$/.test(e.target.value)) {
        setError("pageName", {
          notValid: {
            value: true,
            message: translate("auth.page_name_cannot_contain_symbols"),
          },
        });
      } else {
        clearErrors("pageName"); // Clear the error for 'pageName' field

        const formData = {
          pageName: e.target.value ? e.target.value : null,
        };
        if (!errors?.pageName) {
          // await dispatch(validatePageName(formData));
          setNameLoading(true);
          setTimeout(() => {
            setSearch(formData);
          }, 100);
        }
      }
    } else {
      setError("pageName", {
        required: {
          value: true,
          message: translate("auth.page_name_required"),
        },
      });
    }
  };

  useEffect(() => {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    setSearchTimeout(
      setTimeout(() => {
        if (search) {
          validatePageName(search);
        }
      }, 900)
    );

    return () => clearTimeout(searchTimeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const validatePageName = async (pageName) => {
    const path = "/api/user/validatePageName";
    const url = baseUrl + path;

    try {
      const response = await axios.post(url, pageName);
      setNameLoading(false);

      if (response.data.status === true) {
        setNameAvailable(response.data);
      } else {
        setError("pageName", {
          notAvailable: {
            value: true,
            message: translate("auth.this_username_is_already_taken"),
          },
        });
        setNameAvailable(response.data);
      }
      return response?.data;
    } catch (error) {
      setNameLoading(false);
      toast.error(error.message);
      return error;
    }
  };

  const SubmitHandler = async (data) => {
    const payload = {
      pageName: data.pageName,
      email: data.email,
      code: code,
      recaptchaToken: token,
    };
    if (nameAvailable?.status !== true) {
      reset();
      toast.error("Pagename not available");
    } else {
      await dispatch(registerUser(payload));
      reset();
      setNameAvailable(null);
      dispatch(resetUser());
    }
  };

  // Function to change the language and close the language modal
  const handleChangeLang = (newLang) => {
    onChangeLang(newLang); // Change the language
    setIsOpenLangModal(false); // Close the language modal
    setIsOpenLangMModal(false); // Close the mobile language modal
  };

  const [token, setToken] = useState("");

  const verifyRecaptchaCallback = React.useCallback((token) => {
    setToken(token);
  }, []);

  return (
    <div className="dark:bg-dark-primary">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sign Up | Bil.Bio</title>
        <meta property="og:title" content="Sign Up | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div
        className={`flex flex-col lg:flex-row relative ${
          themeDirection === "rtl" ? "lg:flex-row-reverse" : ""
        }`}
      >
        <div className="block sm:mt-0 sm:items-center p-6 sm:p-10  w-full min-h-screen h-screen overflow-y-auto xsmfold:px-2 xsml:px-5 smm:px-12 md:px-32 lg:px-16 xl:px-28 2xl:px-44">
          <div className="xl:mx-[-55px] bg-white dark:bg-dark-primary flex items-center justify-between flex-wrap">
            <Link to={"/"} className="flex items-center w-[80px] lg:w-[121px]">
              {darkMode ? (
                <BilBioLogoDark className="w-[100%] sm:w-[100%] h-auto" />
              ) : (
                <BilBioLogo className="w-[100%] sm:w-[100%] h-auto" />
              )}
            </Link>
            <div className="relative ml-12">
              {isOpenLangModal && (
                <div
                  ref={modalRef}
                  className="absolute rounded-xl bg-[#fbf7f7]  dark:bg-dark-secondary top-11 -right-2.5"
                >
                  <div className="flex relative rounded-xl w-max flex-col p-2 gap-2">
                    <div className="absolute h-3 w-3 bg-[#fbf7f7] dark:bg-dark-secondary -top-1.5 right-4 rotate-45"></div>
                    {allLangs.map((lang) => (
                      <div
                        key={lang?.value}
                        onClick={() => handleChangeLang(lang?.value)}
                        className={`p-1 px-2 hover:bg-gray-100 dark:hover:bg-dark-primary cursor-pointer rounded-lg ${
                          themeDirection === "rtl" ? "flex-row-reverse" : ""
                        } flex items-center gap-2 min-w-fit`}
                      >
                        <p className="whitespace-nowrap dark:text-color_v1_dark">
                          {lang?.label}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {darkMode ? (
                <GlobeIconDark
                  onClick={() => setIsOpenLangModal(!isOpenLangModal)}
                  className="cursor-pointer ml-2" // Adjust the margin-left as needed
                  ref={iconRef}
                />
              ) : (
                <GlobeIcon
                  onClick={() => setIsOpenLangModal(!isOpenLangModal)}
                  className="cursor-pointer ml-2" // Adjust the margin-left as needed
                  ref={iconRef}
                />
              )}
            </div>
          </div>
          <div className="w-full">
            <div className="mt-5 flex items-center justify-center">
            <div>
              <h1 className="mb-1 text-custom_h5 sm:text-custom_h4 text-center text-heading_color dark:text-color_v1_dark">
                {translate("auth.create_your_account")}
              </h1>

              <h6 className="text-center text-font_light_color dark:text-color_v2_dark text-small2 sm:text-small1 mb-[50px] sm:mb-[48px]">
                {/* Signup to bilbio and create your Biolink NOW! */}
                {translate("auth.signup_to_bilbio_and_create_your_biolink_now")}
              </h6>
            </div>
            </div>

            <GoogleReCaptchaProvider
              reCaptchaKey="6LdE6HspAAAAACPsUd8qMNH1ErUu7bK2CosYHpx0"
              container={{
                element: "[required_id_or_htmlelement]",
                parameters: {
                  badge: "[inline|bottomright|bottomleft]",
                  theme: "dark",
                },
              }}
            >
              <form
                className="flex justify-center"
                onSubmit={handleSubmit((data) => SubmitHandler(data))}
              >
                <div className="max-w-[482px] w-full">
                  <div className="flex justify-center flex-col gap-4 ">
                    <div>
                      <label
                        htmlFor="pageName"
                        className="block ms-[15px] mb-1 text-small2 sm:text-body_copy1 text-heading_color dark:text-color_v1_dark"
                      >
                        {/* Pagename */}
                        {translate("auth.pagename")}
                      </label>
                      <div className="relative">
                        <div className="absolute start-2.5 inset-y-0 flex text-font_light_color dark:text-color_v2_dark text-small2 sm:text-body_copy2 items-center ">
                          <div
                            className={`${
                              errors?.pageName ? "text-state_color_error  dark:text-font_light_color" : "text-font_light_color"
                            }`}
                          >
                            bil.bio/
                          </div>
                        </div>
                        {!nameLoading &&
                          nameAvailable &&
                          nameAvailable?.status === true &&
                          !errors?.pageName && (
                            <div className="absolute end-[13px] sm:end-[15px] inset-y-0 flex text-font_light_color dark:text-color_v2_dark text-small2 sm:text-body_copy2 items-center justify-center">
                              <img src={GrrenFillCheck} alt="..." title="..." />
                            </div>
                          )}
                        {nameLoading && !errors?.pageName && (
                          <div className="absolute end-[13px] sm:end-[15px] inset-y-0 flex items-center justify-center">
                            <svg
                              aria-hidden="true"
                              role="status"
                              className="inline w-5 h-5 text-heading_color animate-spin"
                              viewBox="0 0 100 101"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="#656565"
                              />
                              <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                        )}
                        <input
                          type="text"
                          id="pageName"
                          {...register("pageName")}
                          className={`text-small2 read-only:opacity-50 sm:text-body_copy2 border rounded-md focus:outline-none block w-full p-[13px] sm:p-[15px] py-[5px] sm:py-[7px] ps-[50px] sm:ps-[60px]  dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                            errors?.pageName
                              ? "border-state_color_error placeholder:text-state_color_error dark:bg-dark-primary dark:text-state_color_error"
                              : nameAvailable && nameAvailable?.status === true
                              ? "border-state_color_success pe-[35px] sm:pe-[40px] dark:bg-dark-primary dark:text-color_v2_dark dark:border-color_dark focus:dark:border-font_color"
                              : "border-light_bg_v2 bg-transparent focus:border-font_light_color focus:placeholder:text-heading_color dark:border-color_dark focus:dark:border-font_color"
                          } `}
                          onChange={(e) => pageNameInputChangeHandler(e)}
                          placeholder={translate("auth.enter_page_name")}
                        />
                      </div>
                      {errors?.pageName && (
                        <small className="text-state_color_error text-small3">
                          {errors?.pageName?.required?.message ||
                            errors?.pageName.message}
                        </small>
                      )}
                      {errors?.pageName?.notAvailable && (
                        <small className="text-state_color_error text-small3">
                          {errors?.pageName?.notAvailable?.message}
                        </small>
                      )}
                      {errors?.pageName?.notValid && (
                        <small className="text-state_color_error text-small3">
                          {errors?.pageName?.notValid?.message}
                        </small>
                      )}
                    </div>
                    <div>
                      <label
                        htmlFor="email"
                        className="block ms-[15px] mb-1 text-small2 sm:text-body_copy1 text-heading_color dark:text-color_v1_dark"
                      >
                        {/* Email */}
                        {translate("email")}
                      </label>
                      <input
                        type="email"
                        id="email"
                        {...register("email")}
                        className={`text-small2 sm:text-body_copy2 border rounded-md  focus:outline-none block w-full p-[13px] sm:p-[15px] py-[5px] sm:py-[7px]  dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white focus:placeholder:dark:text-color_v1_dark ${
                          errors?.email
                            ? "border-state_color_error placeholder:text-state_color_error "
                            : "border-light_bg_v2 bg-transparent focus:border-font_light_color focus:placeholder:text-heading_color dark:border-color_dark focus:dark:border-font_color"
                        }`}
                        placeholder={translate("auth.enter_page_email")}
                      />
                      &nbsp;
                      <GoogleReCaptcha onVerify={verifyRecaptchaCallback} />
                      {errors?.email && (
                        <small className="text-state_color_error text-small3">
                          {errors?.email?.message ||
                            errors?.email?.email?.message}
                        </small>
                      )}
                      <p className="text-small3 sm:text-small2 text-start mt-3 dark:text-color_v2_dark">
                        {translate(
                          "auth.by_creating_an_account_you_agreeing_to_our"
                        )}{" "}
                        &nbsp;
                        <Link to={"/privacy-policy"}>
                          <span className="text-main_color text-small3_b sm:text-small2_b">
                            {/* Privacy Policy */}{" "}
                            {translate("footer.privacy_policy")} &nbsp;
                          </span>
                        </Link>
                        {translate("and")} &nbsp;
                        <Link to={"/terms-of-service"}>
                          <span className="text-main_color text-small3_b sm:text-small2_b">
                            {/* Terms & Conditions */}
                            {translate("footer.terms_conditions")} &nbsp;
                          </span>
                        </Link>
                      </p>
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={errors?.pageName || nameLoading || !isValid}
                    className={`cursor-pointer mt-[50px] sm:mt-[48px] bg-main_color text-white rounded-full w-full pt-[13px] pb-[12px] text-small1_bold ${
                      regLoading ? "opacity-70" : ""
                    }`}
                  >
                    {regLoading ? (
                      <svg
                        aria-hidden="true"
                        role="status"
                        className="inline w-4 h-4 mr-3 text-white animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentColor"
                        />
                      </svg>
                    ) : (
                      translate("auth.create_account")
                    )}
                  </button>
                  <p className="text-small1 mt-4 text-center dark:text-color_v2_dark">
                    {/* Already have an account? */}{" "}
                    {translate("descriptions.already_account")} &nbsp;
                    <Link
                      to={"/auth/login"}
                      className="text-main_color text-small1_bold"
                    >
                      {/* LOG IN */}
                      {translate("auth.log_in")}
                    </Link>
                  </p>
                </div>
              </form>
            </GoogleReCaptchaProvider>
          </div>
        </div>

        <div className="hidden w-full lg:block md:h-auto md:w-full h-screen">
          <img
            className="object-cover w-full h-screen"
            src={SignUpImg}
            alt="..."
            title="image"
          />
        </div>
      </div>
    </div>
  );
};

export default SignUp;
